const stackItWithConstants = {
  STACK_IT_DESTROY_MODAL: "STACK_IT_DESTROY_MODAL",
  STACK_IT_SET_SELECTED_STACK: "STACK_IT_SET_SELECTED_STACK",
  STACK_IT_GET_PRODUCT_STACK: "STACK_IT_GET_PRODUCT_STACK",
  STACK_IT_RESPONSE_SUCCESS: "STACK_IT_RESPONSE_SUCCESS",
  STACK_IT_RESPONSE_FAILED: "STACK_IT_RESPONSE_FAILED",
  STACK_IT_GET_PRODUCT_STACK_DETAILS: "STACK_IT_GET_PRODUCT_STACK_DETAILS",
  STACK_IT_PRODUCT_DETAIL_RESPONSE_SUCCESS:
    "STACK_IT_PRODUCT_DETAIL_RESPONSE_SUCCESS",
  STACK_IT_PRODUCT_DETAIL_RESPONSE_FAILED:
    "STACK_IT_PRODUCT_DETAIL_RESPONSE_FAILED",
  STACK_IT_SET_SELECTED_STACKED_CODES: "STACK_IT_SET_SELECTED_STACKED_CODES",
  SET_SELECTED_STACK_METAL: "SET_SELECTED_STACK_METAL",
  STACK_IT_WITH_SET_NEED_PDP_DATA: "STACK_IT_WITH_SET_NEED_PDP_DATA",
  STACK_IT_CART_ADD_SUCCESSFULL: "STACK_IT_CART_ADD_SUCCESSFULL",
  STACK_IT_CART_ADD_FAILED: "STACK_IT_CART_ADD_FAILED",
  STACK_IT_RESET: "STACK_IT_RESET",
}

export default stackItWithConstants
